export default "__VITE_ASSET__CJG5gLfR__"